import { FC, useEffect, useState } from "react";
import Cookies from "../../components/Cookies";
import Footer from "../../components/Footer";
import LoadingSpinner from "../../components/LoadingSpinner";
import CustomPDFViewerSign, {
  FieldsProps,
} from "../../components/Sign/CustomPDFViewer";
import Header from "../../components/Sign/Header";
import { Main } from "../../components/Sign/styled";
import { JsonProvider } from "../../context/JsonContextData";
import { getPositions } from "../../service/getPositions";

const Sign: FC = () => {
  const [fields, setFields] = useState<FieldsProps[] | undefined>(undefined);
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [pdfDName, setPdfName] = useState<string>("");
  const [requesterName, setRequesterName] = useState<string>("");
  const [signatureImage, setSignatureImage] = useState<string>("");
  const [initialImage, setInitialImage] = useState<string>("");
  const [showButton, setShowButton] = useState(false);
  const [hasUserRegister, setHasUserRegister] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState(2);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPositions();

        if (data.signatory_token) {
          sessionStorage.setItem("token_user", data.signatory_token);
        }

        setHasUserRegister(data.has_user_register);

        const keys = Object.keys(data.settings.signatories);
        setFields(data.fields);
        setPdfUrl(data.document.path);
        setPdfName(data.document.name);
        setRequesterName(data.request.requester_name);
        setSignatureImage(data.settings.signatories[keys[0]].signature_image);
        setInitialImage(data.settings.signatories[keys[0]].initial_image);
      } catch (error) {
        console.error("Erro ao renderizar o PDF", error);
      }
    };
    fetchData();
  }, []);

  const handleStepChange = (step: number) => {
    setCurrentStep(step);
  };

  return (
    <JsonProvider>
      <Header
        currentStep={currentStep}
        visible={true}
        showButton={showButton}
      />
      <Main>
        {fields ? (
          <CustomPDFViewerSign
            onVerificationSuccess={() => handleStepChange(3)}
            onPostSuccess={() => handleStepChange(4)}
            pdfUrl={pdfUrl}
            pdfName={pdfDName}
            requesterName={requesterName}
            originalFields={fields}
            signatureImage={signatureImage}
            initialImage={initialImage}
            setShowButton={setShowButton}
            hasUserRegister={hasUserRegister}
          />
        ) : (
          <LoadingSpinner />
        )}
      </Main>
      <Cookies />
      <Footer isAbsolute={true} />
    </JsonProvider>
  );
};

export default Sign;
